import {
  Input,
  Output,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter
} from '@angular/core';
import { Highlightable } from '@angular/cdk/a11y';
import { HistoryTerm, Suggestion } from '~app/modules/generic/models';
import { htmlToPlainText } from '../../../helpers';
import get from 'lodash.get';

@Component({
  selector: 'app-generic-suggestion-item',
  templateUrl: './suggestion-item.component.html',
  styleUrls: ['./suggestion-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionItemComponent implements Highlightable {
  @Input() suggestion: Suggestion | HistoryTerm;
  @Input() searchQuery?: string;
  @Input() isHistory = false;
  @Output() termSelected = new EventEmitter<Suggestion | HistoryTerm>();
  @Output() historyRemoved = new EventEmitter<Suggestion | HistoryTerm>();
  isActive = false;

  constructor(private readonly cdr: ChangeDetectorRef) {

  }

  get hasParentCategory() {
    return get(this.suggestion, ['attrs', 'parent'], null);
  }

  setActiveStyles() {
    this.isActive = true;
    this.cdr.markForCheck();
  }

  setInactiveStyles() {
    this.isActive = false;
    this.cdr.markForCheck();
  }

  onTermSelected(term: Suggestion) {
    const modifiedTerm = {
      ...term,
      value: htmlToPlainText(term.value)
    };
    this.termSelected.emit(modifiedTerm);
  }

  onHistoryRemoved(e, term: HistoryTerm) {
    e.stopPropagation();
    const modifiedTerm = {
      ...term,
      value: htmlToPlainText(term.value)
    };
    this.historyRemoved.emit(modifiedTerm);
  }
}
